import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';

import {
  createCreditApplicationMonitor,
  getCreditApplicationMonitor,
  getSupplierCreditApplicationsMonitor,
  updateCreditApplicationMonitor,
} from '../services/creditApplicationsMonitorService';
import { CreditApplicationsMonitorInitialState } from '../globalSlices/creditApplicationsMonitorSlice';
import { CreditApplicationMonitor } from '@dill/dill-shared/dist/src';

export const createCreditApplicationMonitorExtraReducer = (
  builder: ActionReducerMapBuilder<CreditApplicationsMonitorInitialState>
) => {
  const reducerId = 'createCreditApplicationMonitor';
  builder.addCase(createCreditApplicationMonitor.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createCreditApplicationMonitor.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(createCreditApplicationMonitor.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getCreditApplicationMonitorExtraReducer = (
  builder: ActionReducerMapBuilder<CreditApplicationsMonitorInitialState>
) => {
  const reducerId = 'getCreditApplicationMonitor';
  builder.addCase(getCreditApplicationMonitor.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.creditApplicationMonitor = null;
  });
  builder.addCase(
    getCreditApplicationMonitor.fulfilled,
    (state, action: PayloadAction<any | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload.success && action.payload.data) {
        state.creditApplicationMonitor = action.payload.data;
      }
    }
  );
  builder.addCase(getCreditApplicationMonitor.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getSupplierCreditApplicationsMonitorExtraReducer = (
  builder: ActionReducerMapBuilder<CreditApplicationsMonitorInitialState>
) => {
  const reducerId = 'getSupplierCreditApplicationsMonitor';
  builder.addCase(getSupplierCreditApplicationsMonitor.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    getSupplierCreditApplicationsMonitor.fulfilled,
    (state, action: PayloadAction<any | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload.success && action.payload.data) {
        state.creditApplicationsMonitor = action.payload.data;
      }
    }
  );
  builder.addCase(
    getSupplierCreditApplicationsMonitor.rejected,
    (state, action: PayloadAction<any>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
};

export const updateCreditApplicationMonitorExtraReducer = (
  builder: ActionReducerMapBuilder<CreditApplicationsMonitorInitialState>
) => {
  const reducerId = 'updateCreditApplicationMonitor';
  builder.addCase(updateCreditApplicationMonitor.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    updateCreditApplicationMonitor.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action && action?.payload?.success && action.payload.data) {
        const data = action.payload.data as CreditApplicationMonitor;
        state.creditApplicationMonitor = action.payload.data;
        state.creditApplicationsMonitor = state.creditApplicationsMonitor.map((item) =>
          item.id === data.id ? data : item
        );
      }
    }
  );
  builder.addCase(updateCreditApplicationMonitor.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
